import axios from 'axios';
import * as React from 'react';
import { requestUpdateApTemplate } from '../asyncHelpers/actionPlanTemplateService';
import { RequestStatus } from '../sic-lib/enums/RequestStatus';
import { UpdateApTemplateRequest } from '../sic-lib/types/ApTemplate';
import { useAppDispatch } from '../store/hooks';
import { createToast } from '../store/notify';
import { createErrorToast } from '../utils/notifyHelpers';

/**
 * useAsyncModifyApTemplate
 *
 * @description
 * React hook providing request state management and cancellation for the
 * requestUpdateApTemplate HTTP request
 */
export default function useAsyncModifyApTemplate() {
    const dispatch = useAppDispatch();
    const request_token = axios.CancelToken.source();

    React.useEffect(() => {
        return () => {
            request_token.cancel();
        };
    }, []);

    const [requestStatus, setRequestStatus] = React.useState<RequestStatus>(RequestStatus.none);

    const asyncModifyApTemplate = async (
        templateId: number,
        templateData: UpdateApTemplateRequest,
    ): Promise<boolean | undefined> => {
        try {
            setRequestStatus(RequestStatus.active);

            await requestUpdateApTemplate(templateId, templateData, request_token.token);

            setRequestStatus(RequestStatus.success);

            return true;
        } catch (error: any) {
            if (!axios.isCancel(error)) {
                /* Notify user of failed http request */
                const toastData = createErrorToast('Error while modifying Action Plan Template');

                dispatch(createToast({ toastData }));

                /* Update state */
                setRequestStatus(RequestStatus.error);
            }
        }
    };

    return {
        requestStatus,
        asyncModifyApTemplate,
    };
}
